import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOWNLOAD_STATE_NAME, NOTIFICATION_STATE_NAME } from '../../app.constants';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { Bind } from 'primeng/bind';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent, AccordionModule } from 'primeng/accordion';
import { Ripple, RippleModule } from 'primeng/ripple';
import { Message } from 'primeng/message';
import { FormsModule } from '@angular/forms';
import { InputText, InputTextModule } from 'primeng/inputtext';
import { Textarea, TextareaModule } from 'primeng/textarea';
import { Button, ButtonModule } from 'primeng/button';
import { Divider, DividerModule } from 'primeng/divider';
import { InsightService } from '../../_utils/insight/insight.service';
import { PwaService } from '../../_utils/pwa/pwa.service';
import { SeoService } from '../../_utils/seo/seo.service';
import { StorageService } from '../../_utils/storage/storage.service';
import { ApiService } from '../../_utils/api/api.service';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrl: './help.component.scss',
    imports: [CommonModule, TranslocoDirective, Bind, AccordionModule, RippleModule, Message, FormsModule, InputTextModule, TextareaModule, ButtonModule, DividerModule]
})
export class HelpComponent implements OnInit {
  supportModel: any = {};
  error: string = "";
  success: boolean = false;
  loading: boolean = false;
  config: any = {};
  version: string | undefined = undefined;
  qrCode: string | undefined = undefined;
  os: string | undefined = undefined;
  download: any = { loading: false, error: null, message: null };
  data: any = {};
  
  constructor(private translocoService: TranslocoService, protected sanitizer: DomSanitizer, private deviceDetectorService: DeviceDetectorService, private seoService: SeoService, private insightService: InsightService, private deviceService: DeviceDetectorService, private apiService: ApiService, private pwaService: PwaService, private storageService: StorageService) {
    this.version = PwaService.getVersion();
    const deviceInfo = deviceDetectorService.getDeviceInfo();
    this.os = deviceInfo.os;
  }

  ngOnInit(): void {
    this.translocoService.selectTranslate('faq_seo_description').subscribe(faq_seo_description => {
      this.apiService.getCompany().subscribe({
        next: (data) => {
          this.qrCode = 'data:image/png;base64,' + data.qrcode;
          this.config = data.config;
          this.data = data.data;
          this.seoService.setSeo({
            title: 'FAQ',
            description: faq_seo_description,
            image: data.data.image || data.data.logo,
            url: data.data.pwa_url + '/help'
          });
          this.insightService.send({
            event: 'open_page',
            event_name: 'faq'
          });
        },
        error: (error) => {
          console.error(error);
          this.error = error;
        }
      });
    });
  }

  supportClick(event: any): void {
    this.loading = true;
    this.pwaService.getUserUID().subscribe({
      next: (uid) => {
        let payload = { ...this.supportModel };
        payload.appkey = this.storageService.getAppKey();
        payload.uid = uid;
        payload.data = {
          isInstalled: this.pwaService.isInstalled(),
          os: this.deviceService.os + ' v' + this.deviceService.os_version,
          browser: this.deviceService.browser + ' v' + this.deviceService.browser_version,
          device: this.deviceService.device + ' (' + this.deviceService.deviceType + ')',
          notifyState: this.storageService.getValue(NOTIFICATION_STATE_NAME)
        };

        this.apiService.sendSupportRequest(payload).subscribe({
          next: (response) => {
            this.loading = false;
            this.success = true;
          },
          error: (err) => {
            console.error(err);
            this.error = err;
            this.loading = false;
          },
        });
      },
      error: (err) => {
        console.error(err);
        this.error = err;
        this.loading = false;
      },
    });
  }

  downloadApp(): void {
      this.download.error = this.download.message = null;
      this.download.loading = true;
      this.pwaService.install().subscribe({
        next: (message) => {
          this.download.loading = false;
          this.download.message = message;
          this.storageService.saveValue(DOWNLOAD_STATE_NAME, { status: 'install-accepted', date: Date.now() });
        }, 
        error: (err) => {
          console.error(err);
          this.download.error = err;
          this.download.loading = false;
        },
        complete: () => {
          this.storageService.saveValue(DOWNLOAD_STATE_NAME, { status: 'installed', date: Date.now() });
        }
      });
    }
}
